import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
//const Dashboard = () => import('@/views/DashboardNew')
const Dashboard = () => import('@/views/Dashboard_TFMS')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users 

/*Developer Rahimi Added
/*************************Management***************************/
const DeviceAllocation = () => import('@/views/Management/DeviceAllocation');
const DeviceConfiguration = () => import('@/views/Management/DeviceConfiguration');
const VehicleManagement = () => import('@/views/Management/Vehicles');
const Devices = () => import('@/views/Management/Devices');
const Drivers = () => import('@/views/Management/Drivers');
const Fleets = () => import('@/views/Management/Fleets');
const FleetsAllocation = () => import('@/views/Management/FleetsAllocation');
const Users = () => import('@/views/Management/Users');
const Companies = () => import('@/views/Management/Companies');
const CompanyAssign = () => import('@/views/Management/CompanyAssign');
/*************************MAP***************************/
const newPIN = () => import('@/views/online/NewPin');
const MapHistory = () => import('@/views/online/MapHistory');
const MapControl = () => import('@/views/online/MapControl');
const LineControl = () => import('@/views/online/Line');

const Alarm = () => import('@/views/online/Alarm');
/*************************Report***************************/
const FunctionReport = () => import('@/views/Report/Function');
const FunctionVehicle = () => import('@/views/Report/Vehicle');
const FunctionStop = () => import('@/views/Report/Stop');
const FunctionPark = () => import('@/views/Report/Park');
const MapReport = () => import('@/views/Report/MapReport');
const Line = () => import('@/views/Report/Line');
const FleetMove = () => import('@/views/Report/FleetMove');
const FullFunction = () => import('@/views/Report/FullFunction');
const TotalFunction = () => import('@/views/Report/TotalFunction');
const StationHistory = () => import('@/views/Report/StationHistory');
const FleetsInformation = () => import('@/views/Report/FleetsInformation');
const Violations = () => import('@/views/Report/Violations');
const Crop = () => import('@/views/Report/Crop');
const Sipaad = () => import('@/views/Report/Sipaad');


/*************************Security***************************/
const Roles = () => import('@/views/Security/Roles');
const Role = () => import('@/views/Security/Role');
const ChangePassword = () => import('@/views/Security/ChangePassword');
const Pages = () => import('@/views/Security/Pages');
const Profile = () => import('@/views/Security/Profile');
const ApiAccess = () => import('@/views/Security/ApiAccess');
/*************************Pay*********************/
const Transaction = () => import('@/views/Pay/Transaction');
const Financial = () => import('@/views/Pay/FinancialReport');
const Merchant = () => import('@/views/Pay/Merchant');
const Cart = () => import('@/views/Pay/Cart');
/***********************************************/
const Tariff = () => import('@/views/Tariff/Tariff');
const FleetsTariff = () => import('@/views/Tariff/Fleets');
const DaysTariff = () => import('@/views/Tariff/Days');
const DevicesTariff = () => import('@/views/Tariff/Devices');
const Calender = () => import('@/views/Tariff/Calender');
/**********************Bugs*************** */
const FleetInformation = () => import('@/views/Bugs/FleetInformation');
const BugSipaad = () => import('@/views/Bugs/Sipaad');
/**********************Violations*************** */
const Violations_Add = () => import('@/views/Violations/Add');
const Violations_Define = () => import('@/views/Violations/Define');
/***********************Documents*********************************** */
const Documents = () => import('@/views/Documents/Documents');

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'خانه',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'management',
          redirect: '/management/allocation',
          name: 'مدیریت',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'allocation',
              name: 'تخصیص دستگاه',
              component: DeviceAllocation
            },
            {
              path: 'devices',
              name: 'دستگاه ها',
              component: Devices
            },
            {
              path: 'vehicles',
              name: 'ماشین ها',
              component: VehicleManagement
            },
            {
              path: 'drivers',
              name: 'رانندگان',
              component: Drivers
            },
            {
              path: 'users',
              name: 'کاربران',
              component: Users
            },
            {
              path: 'fleets',
              name: 'خط',
              component: Fleets
            },
            {
              path: 'fleets/allocation',
              name: 'تخصیص دسترسی به خط',
              component: FleetsAllocation
            },
            {
              path: 'device/configuration',
              name: 'پیکربندی دستگاه',
              component: DeviceConfiguration
            },
            {
              path: 'Companies',
              name: 'شرکت ها',
              component: Companies
            },
            {
              path: 'company/assign',
              name: 'شرکت ها',
              component: CompanyAssign
            },
          ]
        },

        {
          path: 'online',
          redirect: '/online/map',
          name: 'برخط',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'map',
              name: 'نقشه',
              component: newPIN
            },
            {
              path: 'control',
              name: 'کنترل نقشه',
              component: MapControl
            },
            {
              path: 'history',
              name: 'تاریخچه',
              component: MapHistory
            },
            {
              path: 'lineControl',
              name: 'کنترل خطوط',
              component: LineControl
            },
            {
              path: 'alarm',
              name: 'اعلان ها',
              component: Alarm
            },
          ]
        },
        {
          path: 'report',
          redirect: '/report/function',
          name: 'گزارشات',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'function',
              name: 'کارکرد خط',
              component: FunctionReport
            },
            {
              path: 'vehicle',
              name: 'کارکرد خودرو',
              component: FunctionVehicle
            },
            {
              path: 'stop',
              name: 'توقف',
              component: FunctionStop
            },
            {
              path: 'park',
              name: 'پارک',
              component: FunctionPark
            },
            {
              path: 'map',
              name: 'نقشه',
              component: MapReport
            },
            {
              path: 'line',
              name: 'خط',
              component: Line
            },
            {
              path: 'FleetMove',
              name: 'جابجایی خط',
              component: FleetMove
            },
            {
              path: 'FullFunction',
              name: 'گزارش کلی خط',
              component: FullFunction
            },
            {
              path: 'TotalFunction',
              name: 'کارکرد کل خط',
              component: TotalFunction
            },
            {
              path: 'StationHistory',
              name: 'تردد در ایستگاه',
              component: StationHistory
            },
            {
              path: 'FleetsInformation',
              name: 'اطلاعات خط',
              component: FleetsInformation
            },
            {
              path: 'Violations',
              name: 'تخلفات',
              component: Violations
            },
            {
              path: 'crop',
              name: 'کراپ  نقشه',
              component: Crop
            },
            {
              path: 'Sipaad',
              name: 'سیپاد',
              component: Sipaad
            },
          ]
        },
        {
          path: 'security',
          redirect: '/security/page',
          name: 'تنظیمات امنیتی',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'roles',
              name: 'نقش ها',
              component: Roles
            },
            {
              path: 'roles/role',
              name: 'نقش',
              component: Role
            },
            {
              path: 'roles/api',
              name: 'سرویس ها',
              component: ApiAccess
            },
            {
              path: 'page',
              name: 'تغییر صفحه',
              component: Pages
            },
            {
              path: 'profile',
              name: 'تغییر پروفایل',
              component: Profile
            },
            {
              path: 'password/change',
              name: 'تغییر کلمه عبور',
              component: ChangePassword
            },
          ]
        },
        {
          path: 'pay',
          redirect: '/pay/transaction',
          name: 'پرداخت',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'transaction',
              name: 'تراکنش ها',
              component: Transaction
            },
            {
              path: 'financial',
              name: 'گزارش مالی',
              component: Financial
            },
            {
              path: 'cart',
              name: 'کارت',
              component: Cart
            },
            {
              path: 'merchant',
              name: 'پذیرندگان',
              component: Merchant
            },
          ]
        },
        {
          path: 'tariff',
          redirect: '/tariff',
          name: 'تعرفه هوشمند',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/',
              name: 'جدول تعرفه',
              component: Tariff
            },
            {
              path: 'calender',
              name: 'تقویم',
              component: Calender
            },
            {
              path: 'devices',
              name: 'جدول اولویت',
              component: DevicesTariff
            },
            {
              path: 'fleets',
              name: 'تعرفه خط',
              component: FleetsTariff
            },
            {
              path: 'days',
              name: 'عنوان روز',
              component: DaysTariff
            },
            
          ]
        },
         {
          path: 'bugs',
          redirect: '/bugs/FleetInformation',
          name: 'نیاز به بررسی',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'FleetInformation',
              name: 'اطلاعات مسیر خط',
              component: FleetInformation
            },
            {
              path: 'sipaad',
              name: 'سیپاد',
              component: BugSipaad
            },
            
            
          ]
        },
        {
          path: 'violations',
          redirect: '/violations/Add',
          name: 'بازرسی',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'Add',
              name: 'ثبت تخلف',
              component: Violations_Add
            },
            {
              path: 'Defines',
              name: 'تعاریف',
              component: Violations_Define
            },
            
            
          ]
        },
        {
          path: 'documents',
          redirect: '/documents',
          name: 'مستندات',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/',
              name: 'مشاهده',
              component: Documents
            },
           
            
            
          ]
        },












  

  
      ]
    },
    {
      path: '/User',
      redirect: '/User/Login',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
}

